export const Global = {
    // API_URL: "https://localhost:7217/api/",
    API_URL: "http://api.brandsnewoutlet.com/api/",
    PHOTO_URL: "http://api.brandsnewoutlet.com/Uploads/",
};